const state = {
  nav: [
    {
      label: "Site Track",
      module: "site_track",
      route: "Site_Track",
      subnav: [
        {
          label: "Assets",
          feature: "assets",
          subnav: [
            {
              label: "Cost of Ownership",
              view: "cost_of_ownership",
              route: "Site_Track/Assets/cost_of_ownership",
              sidewayDisplay: "Cost of Ownership"
            },
            {
              label: "Detailed Cost Of Ownership",
              view: "detailed_cost_of_ownership",
              route: "Site_Track/Assets/detailed_cost_of_ownership",
              sidewayDisplay: "Detailed Cost of Ownership"
            }
          ]
        },
        {
          label: "Inventory",
          feature: "inventory",
          subnav: [
            {
              label: "Inventory State Report",
              view: "current_inventory",
              route: "Site_Track/Inventory/inventory_state_report",
            },
          ]
        },
        {
          label: "PM Audits",
          feature: "pm_audits",
          subnav: [
            {
              label: "PM Completion",
              view: "pm_completion",
              route: "Site_Track/pm_audits/pm_completion",
            },
            {
              label: "PM Audit Report",
              view: "pm_audit_report",
              route: "Site_Track/pm_audits/pm_audit_report",
            },
          ]
        },
        {
          label: "Purchase Orders",
          feature: "purchase_orders",
          subnav: [
            {
              label: "Purchase Orders",
              view: "purchase_orders",
              route: "Site_Track/PurchaseOrders/purchase_orders",
            },
          ]
        },
      ]
    },
    {
      label: "Site Command",
      module: "site_command",
      route: "Site_Command",
      subnav: [
        {
          label: "Controller Counts",
          feature: "washed",
          subnav: [
            {
              label: "Summary",
              view: "summary",
              route: "Site_Command/washed/summary",
              sidewayDisplay: "Controller Summary Report"
            },
            {
              label: "Hourly",
              view: "hourly",
              route: "Site_Command/washed/hourly",
              sidewayDisplay: "Controller Hourly Report"
            },
            {
              label: "Daily",
              view: "daily",
              route: "Site_Command/washed/daily",
              sidewayDisplay: "Controller Daily Report"
            },
            {
              label: "Day of Week",
              view: "day_of_week",
              route: "Site_Command/washed/day_of_week",
              sidewayDisplay: "Controller Day Of Week Report"
            },
            {
              label: "Weather Impact",
              view: "weather_impact",
              route: "Site_Command/washed/weather_impact",
              sidewayDisplay: "Controller Weather Impact Report"
            },
          ]
        },
      ]
    },
    {
      label: "Site Scan",
      module: "site_scan",
      route: "Site_Scan",
      subnav: [
        {
          label: "Chemical",
          feature: "chemical",
          // module: ["site_track", "standalone_chemical"],
          subnav: [
            {
              label: "Chemical Status",
              view: "chemical_breakdown",
              route: "Site_Scan/Chem/chemical_status_report",
            },
            {
              label: "Product Consumption",
              view: "product_consumption",
              route: "Site_Scan/Chem/product_consumption",
            },
            {
              label: "Package Consumption",
              view: "package_consumption",
              route: "Site_Scan/Chem/package_consumption",
            },
            /**{
              label: "7 Day Package Consumption Breakdown",
              view: "package_chemical_consumption",
              route: "Chem/package_chemical_consumption",
            },
            {
              label: "7 Day Chemical Regression - Trailing",
              view: "chem_regress_seven_day_trailing",
              route: "Chem/chem_regress_seven_day_trailing",
            },
            {
              label: "Chemical Consumption",
              view: "chemical_consumption",
              route: "Chem/chemical_consumption",
            },**/
          ]
        },
      ]
    },
    // {
    //   label: "Controller Counts",
    //   feature: "washed",
    //   subnav: [
    //     {
    //       label: "Summary",
    //       view: "summary",
    //       route: "washed/summary",
    //       sidewayDisplay: "Controller Summary Report"
    //     },
    //     {
    //       label: "Hourly",
    //       view: "hourly",
    //       route: "washed/hourly",
    //       sidewayDisplay: "Controller Hourly Report"
    //     },
    //     {
    //       label: "Daily",
    //       view: "daily",
    //       route: "washed/daily",
    //       sidewayDisplay: "Controller Daily Report"
    //     },
    //     {
    //       label: "Day of Week",
    //       view: "day_of_week",
    //       route: "washed/day_of_week",
    //       sidewayDisplay: "Controller Day Of Week Report"
    //     },
    //   ]
    // },
    // {
    //   label: "Assets",
    //   feature: "assets",
    //   subnav: [
    //     {
    //       label: "Cost of Ownership",
    //       view: "cost_of_ownership",
    //       route: "Assets/cost_of_ownership",
    //       sidewayDisplay: "Cost of Ownership"
    //     },
    //     {
    //       label: "Detailed Cost Of Ownership",
    //       view: "detailed_cost_of_ownership",
    //       route: "Assets/detailed_cost_of_ownership",
    //       sidewayDisplay: "Detailed Cost of Ownership"
    //     }
    //   ]
    // },
    // {
    //   label: "PM Audits",
    //   feature: "pm_audits",
    //   subnav: [
    //     {
    //       label: "PM Completion",
    //       view: "pm_completion",
    //       route: "pm_audits/pm_completion",
    //     },
    //     {
    //       label: "PM Audit Report",
    //       view: "pm_audit_report",
    //       route: "pm_audits/pm_audit_report",
    //     },
    //   ]
    // },
    // {
    //   label: "Chemical",
    //   feature: "chemical",
    //   // module: ["site_track", "standalone_chemical"],
    //   subnav: [
    //     {
    //       label: "Chemical Status",
    //       view: "chemical_status",
    //       route: "Chem/chemical_status_report",
    //     },
    //     {
    //       label: "Product Consumption",
    //       view: "product_consumption",
    //       route: "Chem/product_consumption",
    //     },
    //     {
    //       label: "Package Consumption",
    //       view: "package_consumption",
    //       route: "Chem/package_consumption",
    //     },
    //     /**{
    //       label: "7 Day Package Consumption Breakdown",
    //       view: "package_chemical_consumption",
    //       route: "Chem/package_chemical_consumption",
    //     },
    //     {
    //       label: "7 Day Chemical Regression - Trailing",
    //       view: "chem_regress_seven_day_trailing",
    //       route: "Chem/chem_regress_seven_day_trailing",
    //     },
    //     {
    //       label: "Chemical Consumption",
    //       view: "chemical_consumption",
    //       route: "Chem/chemical_consumption",
    //     },**/
    //   ]
    // },
    // {
    //   label: "Inventory",
    //   feature: "inventory",
    //   subnav: [
    //     {
    //       label: "Inventory State Report",
    //       view: "inventory_state",
    //       route: "Inventory/inventory_state_report",
    //     },
    //   ]
    // },
    // {
    //   label: "Purchase Orders",
    //   feature: "purchase_orders",
    //   subnav: [
    //     {
    //       label: "Purchase Orders",
    //       view: "purchase_orders",
    //       route: "PurchaseOrders/purchase_orders",
    //     },
    //   ]
    // },
    {
      label: "Washlink",
      feature: "washlink",
      subnav: [
        {
          label: "Revenue Breakdown",
          view: "revenue_breakdown",
          route: "Washlink/revenue_breakdown",
        },
      ]
    },
  ]
};
const getters = {
  reportsNav: state => state.nav
};

export default {
  state,
  getters
};